<div class="mat-elevation-z2">
  <table mat-table class="full-width-table" matSort aria-label="Elements">
    <ng-container matColumnDef="product_id">
      <th mat-header-cell *matHeaderCellDef>PRODUCT ID</th>
      <td mat-cell *matCellDef="let row">{{row.btFriendlyName}}</td>
    </ng-container>
        <ng-container matColumnDef="product_group">
      <th mat-header-cell *matHeaderCellDef>PRODUCT GROUP</th>
      <td mat-cell *matCellDef="let row">{{row.productGroup}}</td>
    </ng-container>
        <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>PRODUCT</th>
      <td mat-cell *matCellDef="let row">{{row.product}}</td>
    </ng-container>
        <ng-container matColumnDef="installed_firmware">
      <th mat-header-cell *matHeaderCellDef>INSTALLED FIRMWARE</th>
      <td mat-cell *matCellDef="let row">{{row.packageVersion}}</td>
    </ng-container>
        <ng-container matColumnDef="serial_pm">
      <th mat-header-cell *matHeaderCellDef>SERIAL_PM</th>
      <td mat-cell *matCellDef="let row">{{row.serialPm}}</td>
    </ng-container>
    <ng-container matColumnDef="serial_product">
      <th mat-header-cell *matHeaderCellDef>SERIAL_PRODUCT</th>
      <td mat-cell *matCellDef="let row">{{row.serialDevice}}</td>
    </ng-container>
    <ng-container matColumnDef="in_use">
      <th mat-header-cell *matHeaderCellDef>IN USE</th>
      <td mat-cell *matCellDef="let row">{{row.inUse}}</td>
    </ng-container>
    <ng-container matColumnDef="bdk_id">
      <th mat-header-cell *matHeaderCellDef>BDK_ID</th>
      <td mat-cell *matCellDef="let row">{{row.bdkRow}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row (click)="goToDetails(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #paginator [length]="totalDevices()" [pageIndex]="currentPageIndex"
    [pageSize]="currentPageSize" [pageSizeOptions]="[5, 10, 20,40,80]" aria-label="Select page"
    (page)="handlePageEvent($event)">
  </mat-paginator>
</div>